import { render, staticRenderFns } from "./KeywordSuggestions.vue?vue&type=template&id=eb0c46b6&"
import script from "./KeywordSuggestions.vue?vue&type=script&lang=js&"
export * from "./KeywordSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./KeywordSuggestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports